<template>
  <el-config-provider :locale="locale">
    <!-- 区域1：顶部横幅 -->
    <div style="background-color: #FEEFEF">
      <section class="hero-section">
        <div class="hero-content">
          <p class="hero-title">悦高智享交易终端 OrderPro</p>
          <button class="hero-btn" @click="download(version_new_url)">下载Windows端</button>
        </div>
      </section>
    </div>
    <!-- 区域2：历史版本下载 -->
    <div class="section-downloads">
      <div class="container">
        <div class="manual-row">
          <span class="manual-row-lsbbxz">历史版本下载</span>
          <button class="manual-btn" @click="download(manualUrl)">下载操作手册</button>
        </div>

        <div class="manual-row">
          <span>版本支持：windows</span>
        </div>
        <div class="version-list">
          <div class="version-item" v-for="item in versions" :key="item.version_num">
            <div class="version-name">{{ item.version_num }}</div>
            <div class="version-date">{{ item.create_time }}</div>
            <div class="version-notes">{{ item.version_info }}</div>
            <button class="download-btn" @click="download(item.download_url)">下载</button>
          </div>
        </div>
        <div class="manual-row" style="margin-top: 20px">
          <span>版本支持：MacOS</span>
        </div>
        <div class="version-list">
          <div class="version-item" v-for="item in versions_mac" :key="item.version_num">
            <div class="version-name">{{ item.version_num }}</div>
            <div class="version-date">{{ item.create_time }}</div>
            <div class="version-notes">{{ item.version_info }}</div>
            <button class="download-btn" @click="download(item.download_url)">下载</button>
          </div>
        </div>
      </div>
    </div>

  </el-config-provider>

</template>
<script>
  import {
    soft_list
  } from "@/api/system/system";
  import zhCn from "element-plus/lib/locale/lang/zh-cn";
  import {ElMessage} from "element-plus";


  export default {
    components: {

    },
    data() {
      return {
        locale: zhCn,
        username: "",
        version_new_url: "",
        // 区域2：历史版本及手册
        manualUrl: "/downloads/OrderPro-Manual.pdf",
        versions: [],
        versions_mac: []
      };
    },
    created() {
      this.username = this.$store.getters.getUserName;

      this.get_soft_list()
      if (this.username) {

      }

      // this.to_search('all');
    },
    mounted() {
      this.username = this.$store.getters.getUserName;

    },
    methods: {
      download(url) {
        if (!url) {
          ElMessage.warning("下载地址不存在");
          return;
        }
        // 以新窗口打开，便于浏览器直接下载
        window.open(url, "_blank");
      },

      get_soft_list(){
        soft_list().then(
          (res) => {
            console.log("==get_soft_list==", res.data.data)
            this.versions = res.data.data.win
            this.versions_mac = res.data.data.mac
            this.version_new_url = res.data.data.win[0].download_url


          },
          (error) => {
            ElMessage({
              showClose: true,
              message: error,
              type: "warning",
            });
          }
        );
      }

    }
  };
</script>

<style scoped>
  .hero-section {
    width: 100%;
    height: 300px;
    background: url('../../assets/index/cpxz-bg@2x.png') center center / cover no-repeat;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .hero-content {
    text-align: left;
    padding-left: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }

  .hero-title {
    color: #BA0B0B;
    font-size: 28px;
    line-height: 1.4;
    margin: 0 0 16px 0;
  }

  .hero-btn {
    background-color: #BA0B0B;
    color: #FFFFFF;
    border: none;
    border-radius: 4px;
    width: 175px;
    height: 32px;
    font-size: 14px;
    line-height: 16px;
    cursor: pointer;
  }

  /* 区域2：历史版本下载 */
  .section-downloads {
    width: 100%;
    background: #FFFFFF;
    padding: 32px 0 48px 0;
  }

  .container {
    margin: 0 auto;
    padding: 0 15%;
  }

  .section-title {
    font-size: 16px;
    color: #040404;
    margin: unset;
  }

  .manual-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
    font-size: 16px;
    color: #040404;
    font-weight: bold;
  }
  .manual-row-lsbbxz{
    font-size: 20px;
  }

  .manual-btn {
    background-color: #FFFFFF;
    color: #BA0B0B;
    border: 1px solid #BA0B0B;
    border-radius: 4px;
    padding: 6px 12px;
    cursor: pointer;
    height: 32px;
  }

  .version-list {
    border: 1px solid #F0F0F0;
    border-radius: 6px;
    overflow: hidden;
  }

  .version-item {
    display: grid;
    grid-template-columns: 1fr 160px 250px 120px;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border-bottom: 1px solid #F5F5F5;
  }

  .version-item:last-child {
    border-bottom: none;
  }

  .version-name {
    color: #040404;
    font-size: 14px;
  }

  .version-date {
    color: #040404;
    font-size: 14px;
  }

  .version-notes {
    color: #040404;
    font-size: 14px;
    overflow: hidden;
  }

  .download-btn {
    background-color: #FFFFFF;
    color: #BA0B0B;
    border: 1px solid #BA0B0B;
    border-radius: 4px;
    height: 32px;
    font-size: 14px;
    cursor: pointer;
  }

  /* 首个历史版本下载按钮使用红色背景样式 */
  .version-item:first-child .download-btn {
    background-color: #BA0B0B;
    color: #FFFFFF;
    border: none;
  }

  .version-item:first-child .version-name {
    font-weight: 600;
    color: #040404;
    font-size: 14px;
  }

  /* 响应式媒体查询 */
  @media (max-width: 1200px) {
    .hero-content {
      padding-left: 200px;
    }

    .container {
      padding: 0 10%;
    }

    .version-item {
      grid-template-columns: 1fr 140px 200px 100px;
      gap: 10px;
    }
  }

  @media (max-width: 1024px) {
    .hero-content {
      padding-left: 150px;
    }

    .hero-title {
      font-size: 24px;
    }

    .container {
      padding: 0 8%;
    }

    .version-item {
      grid-template-columns: 1fr 120px 180px 90px;
      gap: 8px;
      padding: 10px 12px;
    }

    .version-name,
    .version-date,
    .version-notes {
      font-size: 13px;
    }
  }

  @media (max-width: 768px) {
    .hero-section {
      height: 250px;
      padding: 0 5%;
      width: unset !important;
    }

    .hero-content {
      padding-left: 0;
      text-align: center;
      align-items: center;
    }

    .hero-title {
      font-size: 22px;
      margin-bottom: 20px;
    }

    .hero-btn {
      width: 160px;
      height: 36px;
      font-size: 15px;
    }

    .container {
      padding: 0 30px;
    }

    .section-downloads {
      padding: 24px 0 36px 0;
    }

    .manual-row {
      font-size: 14px;
      margin-bottom: 12px;
      flex-wrap: wrap;
      gap: 10px;
    }
    .manual-row-lsbbxz{
      font-size: 18px;
    }

    .manual-btn {
      padding: 5px 10px;
      height: 30px;
      font-size: 13px;
    }

    .version-item {
      grid-template-columns: 1fr;
      gap: 8px;
      padding: 12px;
      border-bottom: 1px solid #E5E5E5;
    }

    .version-name,
    .version-date,
    .version-notes {
      font-size: 13px;
      margin-bottom: 4px;
    }

    .version-date {
      color: #777;
      font-size: 12px;
    }

    .download-btn {
      width: 100%;
      margin-top: 4px;
    }
  }

  @media (max-width: 480px) {
    .hero-section {
      height: 200px;
      padding: 30px;
      width: unset !important;
    }

    .hero-title {
      font-size: 18px;
      margin-bottom: 15px;
    }

    .hero-btn {
      width: 140px;
      height: 32px;
      font-size: 14px;
    }

    .container {
      padding: 0 30px;
    }

    .section-downloads {
      padding: 20px 0 30px 0;
    }

    .manual-row {
      font-size: 13px;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
    .manual-row-lsbbxz{
      font-size: 16px;
    }

    .manual-btn {
      width: 100%;
      text-align: center;
    }

    .version-item {
      padding: 10px;
    }

    .version-name,
    .version-date,
    .version-notes {
      font-size: 12px;
    }

    .download-btn {
      height: 28px;
      font-size: 12px;
    }
  }

</style>
